import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { AdminPrintCompanyListRequest } from '../../requests/platform/admin-print-company-list.request';
import {
  AdminPrintCompanyActionResponse,
  AdminPrintCompanyIndicatorsResponse,
  PrintCompanyListResponse,
} from '../../responses/platform/admin-print-company-list.response';

@Injectable({
  providedIn: 'root'
})
export class AdminPrintCompanyService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }
  private readonly base = environment.urlApiPlatform + 'AdminPrintCompany/';

  postList(req: AdminPrintCompanyListRequest): Observable<PrintCompanyListResponse> {
    return this.http
      .post<PrintCompanyListResponse>(this.base + 'List', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  indicators(): Observable<AdminPrintCompanyIndicatorsResponse> {
    return this.http
      .get<AdminPrintCompanyIndicatorsResponse>(this.base + 'Indicators', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Grava o início da produção (idempotente). */
  startProduction(idKitPayment: number): Observable<AdminPrintCompanyActionResponse> {
    return this.http
      .post<AdminPrintCompanyActionResponse>(`${this.base}StartProduction/${idKitPayment}`, null, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Confirma a saída da gráfica e avisa o cliente (exige produção iniciada). */
  confirmSend(idKitPayment: number): Observable<AdminPrintCompanyActionResponse> {
    return this.http
      .post<AdminPrintCompanyActionResponse>(`${this.base}ConfirmSend/${idKitPayment}`, null, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** @deprecated use confirmSend */
  ConfirmSend(idKitPayment: number): Observable<AdminPrintCompanyActionResponse> {
    return this.confirmSend(idKitPayment);
  }
}
